import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dotnet-nuke-dev',
  templateUrl: './dotnet-nuke-dev.component.html',
  styleUrls: ['./dotnet-nuke-dev.component.css']
})
export class DotnetNukeDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/dotnet-nuke-dev/dotnet-nuke-dev.component.ts